import { Controller } from "@hotwired/stimulus"

// Trimite un eveniment custom către Meta Pixel (`fbq('trackCustom', ...)`) la
// click pe elementul pe care este montat. Numele evenimentului vine ca
// action param, ca același controller să poată servi mai multe butoane:
//
//   <a data-controller="meta-pixel"
//      data-action="click->meta-pixel#track"
//      data-meta-pixel-event-param="Schedule call">
//
// Pixelul se încarcă doar în producție (shared/_meta_pixel), așa că în
// development / test `window.fbq` lipsește și click-ul este ignorat.
export default class extends Controller {
  track({ params: { event } }) {
    if (!event || typeof window.fbq !== "function") return

    window.fbq("trackCustom", event)
  }
}
